import { Component } from '@angular/core';
import {APIService} from "../../services/APIService";
import {Route, Router} from "@angular/router";

@Component({
  selector: 'app-player-create',
  templateUrl: './player-create.component.html',
  styleUrls: ['./player-create.component.css']
})
export class PlayerCreateComponent {

  public name: string = '';

  constructor(private apiService: APIService,
              private router: Router) {
  }

  create() {
    this.apiService.create(this.name).then((a) => {
      this.router.navigate(['/players/' + this.name]);
    }).catch((e) => {
      console.error(e);
    })
  }
}
